import React from 'react'
import {type HgTagProps} from '../../components/HgTag'
import HgArticleAboutAuthor, {
  type HgArticleAboutAuthorProps,
} from './_components/HgArticleAboutAuthor'
import HgArticleNotesTagGroup from './_components/HgArticleNotesTagGroup'
import HgArticleShareLinks from './_components/HgArticleShareLinks'

export type HgArticleNotesProps = {
  authors: HgArticleAboutAuthorProps[]
  title: string
  tags: HgTagProps[]
}

const HgArticleNotes = ({authors, tags, title}: HgArticleNotesProps) => {
  return (
    <div className="col-span-full grid w-full grid-cols-subgrid pt-s4">
      <div className="col-span-full flex flex-col gap-s4 md:col-span-8 md:col-start-3 lg:col-start-5">
        <HgArticleAboutAuthor authors={authors} />
        <HgArticleNotesTagGroup tags={tags} />
        <HgArticleShareLinks title={title} />
      </div>
    </div>
  )
}

export default HgArticleNotes
